export const type = 'EMITIR_MENSAJE';

const emitirMensaje = (valor) => {
	return {
		type,
		payload: valor,
	};
};

export default emitirMensaje;